import { OVERLAY_REGISTRY, type OverlayControlProps } from "./registry";
import { closeOverlay, dismissOverlay, type OverlayEntry, useOverlayStack } from "./store";

type AnyOverlay = React.ComponentType<Record<string, unknown> & OverlayControlProps>;

function Overlay({ entry }: { entry: OverlayEntry }) {
  const Component = OVERLAY_REGISTRY[entry.kind] as AnyOverlay;
  return (
    <Component
      {...(entry.props as Record<string, unknown>)}
      open={entry.open}
      onClose={() => closeOverlay(entry.id)}
      onExited={() => dismissOverlay(entry.id)}
    />
  );
}

/** Renders the overlay stack. Mounted once, by `GlobalOverlays`. */
export function OverlayHost() {
  const stack = useOverlayStack();
  return (
    <>
      {stack.map((entry) => (
        <Overlay key={entry.id} entry={entry} />
      ))}
    </>
  );
}
